import metadata from './request'
import api from './Url'
import { UserServiceClient } from '../pbs/user_grpc_web_pb'
import { Empty } from '../pbs/common_pb'
import {UserListReq,CreateUserReq,UpdateUserReq,UserSwitchReq,UserDeleteReq} from "../pbs/user_pb"

const service = new UserServiceClient(api,null,null)

/**
 * 获取账户管理列表
 */
export function getuserlist(username,mobile,pageno,pagesize) {
  return new Promise((resolve, reject) => {
    const request = new UserListReq()
    request.setUserFname(username)
    request.setMobile(mobile)
    request.setPageNumber(pageno)
    request.setPageSize(pagesize)
    //  调用客户端相应的grpc方法，发送grpc请求，并接受后台发送回来的返回值
    service.getList(request, metadata(), (err, response) => {
      if (!err) {
        console.log(response.toObject())
        resolve(response.toObject())
      } else {
          reject(err)
      }
    })
  })
}
/**
 * 创建用户
 */
export function createuser(data) {
  return new Promise((resolve, reject) => {
    const request = new CreateUserReq()
    request.setUserName(data.username)
    request.setUserFname(data.name)
    request.setMobile(data.phone)
    request.setPassword(data.password)
    request.setUserType(data.rolename)
    if(sessionStorage.getItem('userType') == "3"){
      console.log(101010)
      request.setSchoolId(data.school)
    }

    //  调用客户端相应的grpc方法，发送grpc请求，并接受后台发送回来的返回值
    service.create(request, metadata(), (err, response) => {
      if (!err) {
        resolve(response)
      } else {
        reject(err)
      }
    })
  })
}
/**
 * 修改用户
 */
export function updateuser(data) {
  console.log(data)
  return new Promise((resolve, reject) => {
    const request = new UpdateUserReq()
    request.setId(data.id)
    request.setUserName(data.username)
    request.setUserFname(data.name)
    request.setMobile(data.phone)
    request.setPassword(data.password)
    request.setUserType(data.rolename)
    if(sessionStorage.getItem('userType') == "3"){  //如果是超级管理员 才可以修改学校
      request.setSchoolId(data.school)
    }
    console.log(2222222222)
    //  调用客户端相应的grpc方法，发送grpc请求，并接受后台发送回来的返回值
    service.update(request, metadata(), (err, response) => {
      if (!err) {
        console.log(response)
        resolve(response)
      } else {
        reject(err)
      }
    })
  })
}
/**
 * 禁言
 */
export function Estoppeluser(data) {
  console.log(data)
  return new Promise((resolve, reject) => {
    const request = new UserSwitchReq()
    console.log(request)
    request.setId(data.id)
    request.setTurnOn(data.bannedToPost)
    //  调用客户端相应的grpc方法，发送grpc请求，并接受后台发送回来的返回值
    service.banToPost(request, metadata(), (err, response) => {
      if (!err) {
        resolve(response)
      } else {
        reject(err)
      }
    })
  })
}
/**
 * 禁用
 */
export function Banuser(data) {
  return new Promise((resolve, reject) => {
    const request = new UserSwitchReq()
    request.setId(data.id)
    request.setTurnOn(data.status)
    //  调用客户端相应的grpc方法，发送grpc请求，并接受后台发送回来的返回值
    service.ban(request, metadata(), (err, response) => {
      if (!err) {
        resolve(response)
      } else {
        reject(err)
      }
    })
  })
}
/**
 *
 */
export function Deleteuser(data) {
  return new Promise((resolve, reject) => {
    const request = new UserDeleteReq()
    request.setId(data.id)
    //  调用客户端相应的grpc方法，发送grpc请求，并接受后台发送回来的返回值
    service.delete(request, metadata(), (err, response) => {
      if (!err) {
        resolve(response)
      } else {
        reject(err)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/account.js